import { Descriptions } from "antd";
import { formatDuration, sumarDuraciones } from "utils";

// lo podes extraer a un utils si lo usas en varios lados
const calcularTotales = (tramos) => {
  const duraciones = tramos
    ?.filter(e => typeof e.duracion === "string" && e.duracion.includes(":"))
    .map(e => e.duracion);

  const duracionTotal = duraciones?.length ? sumarDuraciones(duraciones) : "";
  const kmTotales = tramos?.reduce((acc, tramo) => acc + (tramo.km || 0), 0);

  return { duracionTotal, kmTotales };
};

const ResumenRecorrido = ({ tramos }) => {
  const { duracionTotal, kmTotales } = calcularTotales(tramos);

  return (
    <Descriptions
      column={1}
      size="small"
      labelStyle={{ width: 105 }}
    >
      {duracionTotal && 
        <Descriptions.Item label="Total duración">
          {formatDuration(duracionTotal)}
        </Descriptions.Item>
      }
      {kmTotales > 0 &&
        <Descriptions.Item label="Total recorrido">
          {kmTotales} km
        </Descriptions.Item>
      }
    </Descriptions>
  );
};

export default ResumenRecorrido;